import axios from "axios";

// Configuration based on environment
const API_CONFIG = {
  // Change this to switch between modes: 'sandbox' or 'development'
  MODE: process.env.REACT_APP_MODE || "sandbox",
  BASE_URL: process.env.REACT_APP_API_URL || "/api",
};

// Configure axios defaults
if (API_CONFIG.MODE === "development") {
  axios.defaults.baseURL = API_CONFIG.BASE_URL;

  // Interceptor to add auth token
  axios.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("token");
      if (token && token.startsWith("jwt_")) {
        // Only add real JWT tokens, not fake ones
        const realToken = token.replace("jwt_", "");
        config.headers["Authorization"] = `Bearer ${realToken}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  // Response interceptor for error handling
  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response?.status === 401) {
        // Token expired or invalid
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
      return Promise.reject(error);
    }
  );
}

// Sandbox data (existing hardcoded data)
const SANDBOX_DATA = {
  users: [
    {
      id: "1",
      name: "Admin User",
      email: "admin@teamscout.com",
      role: "admin",
      department: "Athletics",
      school: "State University",
      createdAt: "2023-01-01T00:00:00.000Z",
    },
    {
      id: "2",
      name: "Coach Smith",
      email: "coach@teamscout.com",
      role: "coach",
      department: "Football",
      school: "State University",
      createdAt: "2023-01-02T00:00:00.000Z",
    },
    {
      id: "3",
      name: "Scout Johnson",
      email: "scout@teamscout.com",
      role: "scout",
      department: "Basketball",
      school: "State University",
      createdAt: "2023-01-03T00:00:00.000Z",
    },
  ],
  // credentials: [
  //   { email: "admin@teamscout.com", password: "password123", userId: "1" },
  //   { email: "coach@teamscout.com", password: "coach123", userId: "2" },
  //   { email: "scout@teamscout.com", password: "scout123", userId: "3" },
  // ],
  prospects: Array.from({ length: 50 }, (_, i) => {
    const firstName = [
      "John",
      "Jane",
      "Mike",
      "Sarah",
      "Alex",
      "Chris",
      "Jessica",
      "David",
    ][Math.floor(Math.random() * 8)];
    const lastName = [
      "Smith",
      "Johnson",
      "Williams",
      "Brown",
      "Jones",
      "Miller",
      "Davis",
      "Garcia",
    ][Math.floor(Math.random() * 8)];
    const position = [
      "Quarterback",
      "Running Back",
      "Wide Receiver",
      "Tight End",
      "Point Guard",
      "Shooting Guard",
      "Forward",
      "Center",
    ][Math.floor(Math.random() * 8)];
    const state = ["CA", "TX", "FL", "NY", "IL", "PA", "OH", "GA"][
      Math.floor(Math.random() * 8)
    ];
    const city = [
      "Los Angeles",
      "Houston",
      "Miami",
      "New York",
      "Chicago",
      "Philadelphia",
      "Columbus",
      "Atlanta",
    ][Math.floor(Math.random() * 8)];

    return {
      id: `${i + 1}`,
      firstName,
      lastName,
      position,
      highSchool: [
        "Lincoln High",
        "Washington High",
        "Jefferson High",
        "Central High",
        "Eastside High",
        "Westview High",
        "Northside Prep",
        "South High",
      ][Math.floor(Math.random() * 8)],
      address: {
        city,
        state,
        country: "USA",
      },
      graduationYear: 2024 + Math.floor(Math.random() * 4),
      recruitingStatus: [
        "prospect",
        "contacted",
        "interested",
        "offered",
        "committed",
        "signed",
        "enrolled",
        "inactive",
      ][Math.floor(Math.random() * 8)],
      rating: Math.floor(Math.random() * 5) + 1,
      aiScore: Math.floor(Math.random() * 40) + 60,
      email: `${firstName.toLowerCase()}.${lastName.toLowerCase()}@email.com`,
      phone: `555-${String(Math.floor(Math.random() * 900) + 100)}-${String(
        Math.floor(Math.random() * 9000) + 1000
      )}`,
      academics: {
        gpa: parseFloat((Math.random() * 2 + 2).toFixed(2)),
      },
      height: `${Math.floor(Math.random() * 12) + 66}"`,
      weight: Math.floor(Math.random() * 80) + 150,
      notes: [
        {
          text: "Strong player with good fundamentals",
          category: "general",
          createdBy: "1",
          createdAt: new Date().toISOString(),
        },
      ],
      events: [
        {
          id: `${i + 1}_1`,
          date: new Date(
            Date.now() - Math.random() * 90 * 24 * 60 * 60 * 1000
          ).toISOString(),
          type: [
            "unofficial_visit",
            "official_visit",
            "offered",
            "commitment",
            "offer_withdrawal",
            "decommitted",
            "off_campus_visit",
            "home_visit",
          ][Math.floor(Math.random() * 8)],
          school: [
            "Texas Tech University",
            "University of Houston",
            "SMU",
            "Baylor University",
            "TCU",
            "University of Texas",
            "Texas A&M",
            "Rice University",
          ][Math.floor(Math.random() * 8)],
          status: ["pending", "accepted", "declined"][
            Math.floor(Math.random() * 3)
          ],
          amount: ["Full Scholarship", "Partial Scholarship", "Walk-on"][
            Math.floor(Math.random() * 3)
          ],
          details: "Event details for this prospect",
          notes: "Additional notes about this event",
          createdBy: "1",
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
        {
          id: `${i + 1}_2`,
          date: new Date(
            Date.now() - Math.random() * 60 * 24 * 60 * 60 * 1000
          ).toISOString(),
          type: [
            "unofficial_visit",
            "official_visit",
            "offered",
            "commitment",
            "offer_withdrawal",
            "decommitted",
            "off_campus_visit",
            "home_visit",
          ][Math.floor(Math.random() * 8)],
          school: [
            "Texas Tech University",
            "University of Houston",
            "SMU",
            "Baylor University",
            "TCU",
            "University of Texas",
            "Texas A&M",
            "Rice University",
          ][Math.floor(Math.random() * 8)],
          status: ["pending", "accepted", "declined"][
            Math.floor(Math.random() * 3)
          ],
          amount: ["Full Scholarship", "Partial Scholarship", "Walk-on"][
            Math.floor(Math.random() * 3)
          ],
          details: "Another event for this prospect",
          notes: "More notes about this event",
          createdBy: "1",
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        },
      ],
      createdAt: new Date().toISOString(),
      createdBy: "1",
    };
  }),
  coaches: Array.from({ length: 20 }, (_, i) => ({
    id: `${i + 1}`,
    firstName: [
      "Mike",
      "John",
      "David",
      "Robert",
      "James",
      "Bill",
      "Tom",
      "Steve",
    ][Math.floor(Math.random() * 8)],
    lastName: [
      "Smith",
      "Johnson",
      "Williams",
      "Brown",
      "Jones",
      "Miller",
      "Davis",
      "Wilson",
    ][Math.floor(Math.random() * 8)],
    email: `coach${i + 1}@university.com`,
    phone: `555-${String(Math.floor(Math.random() * 900) + 100)}-${String(
      Math.floor(Math.random() * 9000) + 1000
    )}`,
    school: [
      "State University",
      "Tech University",
      "City College",
      "Central University",
      "Metro State",
      "Regional College",
    ][Math.floor(Math.random() * 6)],
    position: [
      "Head Coach",
      "Assistant Coach",
      "Recruiting Coordinator",
      "Position Coach",
    ][Math.floor(Math.random() * 4)],
    city: [
      "Los Angeles",
      "Houston",
      "Miami",
      "New York",
      "Chicago",
      "Philadelphia",
      "Columbus",
      "Atlanta",
    ][Math.floor(Math.random() * 8)],
    state: ["CA", "TX", "FL", "NY", "IL", "PA", "OH", "GA"][
      Math.floor(Math.random() * 8)
    ],
    region: ["West", "Southwest", "Southeast", "Northeast", "Midwest"][
      Math.floor(Math.random() * 5)
    ],
    sports: [
      ["Football"],
      ["Basketball"],
      ["Baseball"],
      ["Football", "Basketball"],
    ][Math.floor(Math.random() * 4)],
    yearsExperience: Math.floor(Math.random() * 25) + 1,
    championships: Math.floor(Math.random() * 6),
    bio: `Experienced coach with a passion for developing young athletes and building championship programs. Known for innovative training methods and strong relationships with players and families.`,
    previousSchools:
      i % 3 === 0
        ? [
            {
              school: "Previous High School",
              position: "Assistant Coach",
              years: "2015-2018",
              fromYear: 2015,
              toYear: 2018,
            },
          ]
        : [],
    isFormerPlayer: Math.random() > 0.5,
    playerYears: Math.random() > 0.5 ? "2005-2009" : "",
    playerFromYear: Math.random() > 0.5 ? 2005 : null,
    playerToYear: Math.random() > 0.5 ? 2009 : null,
    playerSchool: Math.random() > 0.5 ? "State University" : "",
    playerPosition: Math.random() > 0.5 ? "Quarterback" : "",
    createdAt: new Date().toISOString(),
  })),
};

// API utility functions
const api = {
  // Generic HTTP methods
  get: async (url, config = {}) => {
    if (API_CONFIG.MODE === "sandbox") {
      // Handle sandbox mode for generic requests
      throw new Error(`Sandbox mode doesn't support generic GET ${url}`);
    } else {
      const response = await axios.get(url, config);
      return response.data;
    }
  },

  post: async (url, data, config = {}) => {
    if (API_CONFIG.MODE === "sandbox") {
      // Handle sandbox mode for generic requests
      throw new Error(`Sandbox mode doesn't support generic POST ${url}`);
    } else {
      const response = await axios.post(url, data, config);
      return response.data;
    }
  },

  put: async (url, data, config = {}) => {
    if (API_CONFIG.MODE === "sandbox") {
      // Handle sandbox mode for generic requests
      throw new Error(`Sandbox mode doesn't support generic PUT ${url}`);
    } else {
      const response = await axios.put(url, data, config);
      return response.data;
    }
  },

  delete: async (url, config = {}) => {
    if (API_CONFIG.MODE === "sandbox") {
      // Handle sandbox mode for generic requests
      throw new Error(`Sandbox mode doesn't support generic DELETE ${url}`);
    } else {
      const response = await axios.delete(url, config);
      return response.data;
    }
  },

  // Authentication
  auth: {
    login: async (email, password) => {
      if (API_CONFIG.MODE === "sandbox") {
        // Simulate API delay
        await new Promise((resolve) => setTimeout(resolve, 800));

        const cred = SANDBOX_DATA.credentials.find(
          (c) => c.email === email && c.password === password
        );
        if (!cred) throw new Error("Invalid credentials");

        const user = SANDBOX_DATA.users.find((u) => u.id === cred.userId);
        const token = `fake_token_${Date.now()}_${user.id}`;

        return { token, user };
      } else {
        const response = await axios.post("/auth/login", { email, password });
        return response.data;
      }
    },

    register: async (userData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 1000));

        const emailExists = SANDBOX_DATA.users.some(
          (u) => u.email === userData.email
        );
        if (emailExists) throw new Error("Email already in use");

        const newUser = {
          id: String(SANDBOX_DATA.users.length + 1),
          name: userData.name,
          email: userData.email,
          role: userData.role || "user",
          department: userData.department || "General",
          school: userData.school || "State University",
          createdAt: new Date().toISOString(),
        };

        SANDBOX_DATA.users.push(newUser);
        const token = `fake_token_${Date.now()}_${newUser.id}`;

        return { token, user: newUser };
      } else {
        const response = await axios.post("/auth/register", userData);
        return response.data;
      }
    },

    getCurrentUser: async () => {
      if (API_CONFIG.MODE === "sandbox") {
        const token = localStorage.getItem("token");
        if (!token) throw new Error("No token found");

        const userId = token.split("_").pop();
        const user = SANDBOX_DATA.users.find((u) => u.id === userId);
        if (!user) throw new Error("User not found");

        return user;
      } else {
        const response = await axios.get("/auth/me");
        return response.data;
      }
    },
  },

  // Boards
  boards: {
    getAll: async () => {
      if (API_CONFIG.MODE === "sandbox") {
        // This will be handled by boardService
        throw new Error("Use boardService for sandbox mode");
      } else {
        const response = await axios.get("/boards");
        return response.data.data || response.data;
      }
    },

    create: async (boardData) => {
      if (API_CONFIG.MODE === "sandbox") {
        // This will be handled by boardService
        throw new Error("Use boardService for sandbox mode");
      } else {
        const response = await axios.post("/boards", boardData);
        return response.data.data || response.data;
      }
    },

    update: async (id, boardData) => {
      if (API_CONFIG.MODE === "sandbox") {
        // This will be handled by boardService
        throw new Error("Use boardService for sandbox mode");
      } else {
        const response = await axios.put(`/boards/${id}`, boardData);
        return response.data.data || response.data;
      }
    },

    delete: async (id) => {
      if (API_CONFIG.MODE === "sandbox") {
        // This will be handled by boardService
        throw new Error("Use boardService for sandbox mode");
      } else {
        const response = await axios.delete(`/boards/${id}`);
        return response.data;
      }
    },
  },

  // Prospects
  prospects: {
    get: async (params = {}) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 500));
        // For sandbox, simulate the backend response format
        const prospects = SANDBOX_DATA.prospects;
        return {
          success: true,
          count: prospects.length,
          total: prospects.length,
          data: prospects,
          pagination: {},
        };
      } else {
        const response = await axios.get("/prospects", { params });
        return response.data;
      }
    },

    getAll: async (params = {}) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 500));
        return SANDBOX_DATA.prospects;
      } else {
        // Set a high limit to get all prospects, or use pagination
        const allParams = { ...params, limit: 1000 }; // Get up to 1000 prospects
        const response = await axios.get("/prospects", { params: allParams });
        // Backend returns { success, count, data: [...] }, we need just the data array
        return response.data.data || response.data;
      }
    },

    getStatusCounts: async () => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        // Calculate status counts from sandbox data
        const statusCounts = {};
        SANDBOX_DATA.prospects.forEach((prospect) => {
          const status = prospect.recruitingStatus || "prospect";
          statusCounts[status] = (statusCounts[status] || 0) + 1;
        });

        return Object.entries(statusCounts).map(([status, count]) => ({
          _id: status,
          count,
        }));
      } else {
        // In development mode, calculate from the prospects data
        // Since there's no dedicated endpoint, we'll get all prospects and calculate
        const response = await axios.get("/prospects");
        const prospects = response.data.data || response.data;

        const statusCounts = {};
        prospects.forEach((prospect) => {
          const status = prospect.recruitingStatus || "prospect";
          statusCounts[status] = (statusCounts[status] || 0) + 1;
        });

        return Object.entries(statusCounts).map(([status, count]) => ({
          _id: status,
          count,
        }));
      }
    },

    getById: async (id) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        const prospect = SANDBOX_DATA.prospects.find((p) => p.id === id);
        if (!prospect) throw new Error("Prospect not found");
        return prospect;
      } else {
        const response = await axios.get(`/prospects/${id}`);
        // Backend might return { success, data: {...} } or just the object
        return response.data.data || response.data;
      }
    },

    create: async (prospectData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 800));
        const newProspect = {
          ...prospectData,
          id: String(SANDBOX_DATA.prospects.length + 1),
          createdAt: new Date().toISOString(),
        };
        SANDBOX_DATA.prospects.push(newProspect);
        return newProspect;
      } else {
        const response = await axios.post("/prospects", prospectData);
        // Backend might return { success, data: {...} } or just the object
        return response.data.data || response.data;
      }
    },

    update: async (id, prospectData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 600));
        const index = SANDBOX_DATA.prospects.findIndex((p) => p.id === id);
        if (index === -1) throw new Error("Prospect not found");

        SANDBOX_DATA.prospects[index] = {
          ...SANDBOX_DATA.prospects[index],
          ...prospectData,
        };
        return SANDBOX_DATA.prospects[index];
      } else {
        const response = await axios.put(`/prospects/${id}`, prospectData);
        // Backend might return { success, data: {...} } or just the object
        return response.data.data || response.data;
      }
    },

    // Events CRUD operations
    getEvents: async (prospectId) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        const prospect = SANDBOX_DATA.prospects.find(
          (p) => p.id === prospectId
        );
        return prospect?.events || [];
      } else {
        const response = await axios.get(`/prospects/${prospectId}/events`);
        return response.data.data || response.data;
      }
    },

    addEvent: async (prospectId, eventData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 500));
        const prospect = SANDBOX_DATA.prospects.find(
          (p) => p.id === prospectId
        );
        if (!prospect) throw new Error("Prospect not found");

        const newEvent = {
          ...eventData,
          id: Date.now().toString(),
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        };

        if (!prospect.events) prospect.events = [];
        prospect.events.push(newEvent);

        return newEvent;
      } else {
        const response = await axios.post(
          `/prospects/${prospectId}/events`,
          eventData
        );
        return response.data.data || response.data;
      }
    },

    updateEvent: async (prospectId, eventId, eventData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 500));
        const prospect = SANDBOX_DATA.prospects.find(
          (p) => p.id === prospectId
        );
        if (!prospect) throw new Error("Prospect not found");

        const eventIndex = prospect.events?.findIndex((e) => e.id === eventId);
        if (eventIndex === -1) throw new Error("Event not found");

        prospect.events[eventIndex] = {
          ...prospect.events[eventIndex],
          ...eventData,
          updatedAt: new Date().toISOString(),
        };

        return prospect.events[eventIndex];
      } else {
        const response = await axios.put(
          `/prospects/${prospectId}/events/${eventId}`,
          eventData
        );
        return response.data.data || response.data;
      }
    },

    deleteEvent: async (prospectId, eventId) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 500));
        const prospect = SANDBOX_DATA.prospects.find(
          (p) => p.id === prospectId
        );
        if (!prospect) throw new Error("Prospect not found");

        if (!prospect.events)
          return { success: true, message: "Event deleted successfully" };

        const eventIndex = prospect.events.findIndex((e) => e.id === eventId);
        if (eventIndex === -1) throw new Error("Event not found");

        prospect.events.splice(eventIndex, 1);

        return { success: true, message: "Event deleted successfully" };
      } else {
        const response = await axios.delete(
          `/prospects/${prospectId}/events/${eventId}`
        );
        return response.data;
      }
    },

    delete: async (id) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 400));
        const index = SANDBOX_DATA.prospects.findIndex((p) => p.id === id);
        if (index === -1) throw new Error("Prospect not found");

        SANDBOX_DATA.prospects.splice(index, 1);
        return { message: "Prospect deleted successfully" };
      } else {
        const response = await axios.delete(`/prospects/${id}`);
        return response.data;
      }
    },

    import: async (formData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 2000));
        // Simulate import success for sandbox mode
        const mockImportCount = Math.floor(Math.random() * 10) + 5;
        return {
          success: true,
          message: `Successfully imported ${mockImportCount} prospects`,
          importedCount: mockImportCount,
          errors:
            mockImportCount > 8
              ? ["Sample warning: Some rows had missing data"]
              : null,
        };
      } else {
        const response = await axios.post("/prospects/import", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
        return response.data;
      }
    },
  },

  // Videos
  videos: {
    getProspectVideos: async (prospectId, filters = {}) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        // Return test videos for sandbox mode
        const testVideos = [
          {
            _id: "test-1",
            title: "Sample YouTube Video - React Player Demo",
            url: "https://www.youtube.com/watch?v=LXb3EKWsInQ",
            notes: [],
            platform: "youtube",
            category: "highlight",
            uploadDate: new Date().toISOString(),
          },
          {
            _id: "test-2",
            title: "Sample MP4 Video",
            url: "https://commondatastorage.googleapis.com/gtv-videos-bucket/sample/BigBuckBunny.mp4",
            notes: [],
            platform: "direct",
            category: "highlight",
            uploadDate: new Date().toISOString(),
          },
          {
            _id: "test-3",
            title: "Sample Vimeo Video",
            url: "https://vimeo.com/90509568",
            notes: [],
            platform: "vimeo",
            category: "highlight",
            uploadDate: new Date().toISOString(),
          },
          {
            _id: "test-4",
            title: "Sample Hudl Video",
            url: "https://www.hudl.com/video/657c859abd6b0e0b80ad6e73",
            notes: [],
            platform: "hudl",
            category: "highlight",
            uploadDate: new Date().toISOString(),
          },
        ];
        return { success: true, data: testVideos, count: testVideos.length };
      } else {
        const params = new URLSearchParams();
        if (filters.category) params.append("category", filters.category);
        if (filters.platform) params.append("platform", filters.platform);

        const response = await axios.get(
          `/videos/prospect/${prospectId}?${params}`
        );
        return response.data;
      }
    },

    getVideo: async (videoId) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 200));
        // Return test video for sandbox mode
        const testVideo = {
          _id: videoId,
          title: "Sample Video",
          url: "https://www.youtube.com/watch?v=LXb3EKWsInQ",
          notes: [],
          platform: "youtube",
          category: "highlight",
          uploadDate: new Date().toISOString(),
        };
        return { success: true, data: testVideo };
      } else {
        const response = await axios.get(`/videos/${videoId}`);
        return response.data;
      }
    },

    create: async (videoData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 500));
        const newVideo = {
          _id: `video-${Date.now()}`,
          ...videoData,
          notes: [],
          uploadDate: new Date().toISOString(),
        };
        return { success: true, data: newVideo };
      } else {
        const response = await axios.post("/videos", videoData);
        return response.data;
      }
    },

    update: async (videoId, updateData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 400));
        const updatedVideo = {
          _id: videoId,
          ...updateData,
          updatedAt: new Date().toISOString(),
        };
        return { success: true, data: updatedVideo };
      } else {
        const response = await axios.put(`/videos/${videoId}`, updateData);
        return response.data;
      }
    },

    delete: async (videoId) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        return { success: true, message: "Video deleted successfully" };
      } else {
        const response = await axios.delete(`/videos/${videoId}`);
        return response.data;
      }
    },

    addNote: async (videoId, noteData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        const newNote = {
          _id: `note-${Date.now()}`,
          ...noteData,
          createdAt: new Date().toISOString(),
        };
        const video = {
          _id: videoId,
          notes: [newNote],
          updatedAt: new Date().toISOString(),
        };
        return {
          success: true,
          data: video,
          message: "Note added successfully",
        };
      } else {
        const response = await axios.post(`/videos/${videoId}/notes`, noteData);
        return response.data;
      }
    },

    updateNote: async (videoId, noteId, updateData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        const video = {
          _id: videoId,
          notes: [
            { _id: noteId, ...updateData, updatedAt: new Date().toISOString() },
          ],
          updatedAt: new Date().toISOString(),
        };
        return {
          success: true,
          data: video,
          message: "Note updated successfully",
        };
      } else {
        const response = await axios.put(
          `/videos/${videoId}/notes/${noteId}`,
          updateData
        );
        return response.data;
      }
    },

    deleteNote: async (videoId, noteId) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        return { success: true, message: "Note deleted successfully" };
      } else {
        const response = await axios.delete(
          `/videos/${videoId}/notes/${noteId}`
        );
        return response.data;
      }
    },

    getAnalytics: async () => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 400));
        return {
          success: true,
          data: {
            overview: {
              totalVideos: 12,
              totalViews: 156,
              avgViews: 13,
              platforms: ["youtube", "vimeo", "direct"],
              categories: ["highlight", "training"],
            },
            byPlatform: [
              { _id: "youtube", count: 8, totalViews: 120 },
              { _id: "vimeo", count: 3, totalViews: 24 },
              { _id: "direct", count: 1, totalViews: 12 },
            ],
          },
        };
      } else {
        const response = await axios.get("/videos/analytics/stats");
        return response.data;
      }
    },

    search: async (searchParams) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 400));
        // Return filtered test videos for sandbox
        return {
          success: true,
          data: [],
          pagination: { total: 0, page: 1, pages: 0, limit: 50 },
        };
      } else {
        const params = new URLSearchParams();
        if (searchParams.search) params.append("search", searchParams.search);
        if (searchParams.category)
          params.append("category", searchParams.category);
        if (searchParams.platform)
          params.append("platform", searchParams.platform);
        if (searchParams.prospect)
          params.append("prospect", searchParams.prospect);
        if (searchParams.limit) params.append("limit", searchParams.limit);
        if (searchParams.page) params.append("page", searchParams.page);

        const response = await axios.get(`/videos?${params}`);
        return response.data;
      }
    },
  },

  // Activities
  activities: {
    getRecent: async (limit = 20) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        // Return mock activities for sandbox mode
        return [
          {
            id: 1,
            type: "prospect_added",
            actor: { name: "Coach Smith" },
            target: { entityName: "John Johnson" },
            action: {
              verb: "added",
              description: "Added new prospect: John Johnson",
            },
            timestamp: new Date(Date.now() - 1000 * 60 * 30).toISOString(), // 30 minutes ago
          },
          {
            id: 2,
            type: "prospect_imported",
            actor: { name: "Coach Johnson" },
            target: { entityName: "25 prospects" },
            action: {
              verb: "imported",
              description: "Imported 25 prospects from prospects.xlsx",
            },
            timestamp: new Date(Date.now() - 1000 * 60 * 60 * 2).toISOString(), // 2 hours ago
          },
          {
            id: 3,
            type: "note_added",
            actor: { name: "Scout Williams" },
            target: { entityName: "Mike Davis" },
            action: {
              verb: "noted",
              description: "Added note to prospect: Mike Davis",
            },
            timestamp: new Date(Date.now() - 1000 * 60 * 60 * 4).toISOString(), // 4 hours ago
          },
        ];
      } else {
        const response = await axios.get(`/activities/recent?limit=${limit}`);
        return response.data;
      }
    },

    getAll: async (params = {}) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 400));
        return {
          activities: [
            {
              id: 1,
              type: "prospect_added",
              actor: { name: "Coach Smith" },
              target: { entityName: "John Johnson" },
              action: {
                verb: "added",
                description: "Added new prospect: John Johnson",
              },
              timestamp: new Date(Date.now() - 1000 * 60 * 30).toISOString(),
            },
          ],
          pagination: { page: 1, limit: 50, total: 1, pages: 1 },
        };
      } else {
        const response = await axios.get("/activities", { params });
        return response.data;
      }
    },

    create: async (data) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        return { id: Date.now(), ...data };
      } else {
        const response = await axios.post("/activities", data);
        return response.data;
      }
    },
  },

  // Prospect Notes
  prospectNotes: {
    getAll: async (prospectId, filters = {}) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        // Return mock notes data
        return {
          success: true,
          data: [
            {
              _id: "1",
              text: "Coach Smith mentioned he has a promising junior quarterback named Robert Davis who could be a good fit for our system.",
              category: "recruiting",
              theme: "team_notes",
              source: "main",
              priority: "medium",
              createdBy: { _id: "1", name: "John Davis" },
              createdAt: "2025-05-15T14:30:00",
              updatedAt: "2025-05-15T14:30:00",
            },
            {
              _id: "2",
              text: "Coach prefers to be contacted in the evenings after practice (usually after 6pm). Don't call during school hours.",
              category: "important",
              theme: "coaching_staff_notes",
              source: "main",
              priority: "high",
              pinned: true,
              createdBy: { _id: "2", name: "Sarah Wilson" },
              createdAt: "2025-05-10T09:15:00",
              updatedAt: "2025-05-10T09:15:00",
            },
            {
              _id: "3",
              text: "Excellent footwork and throwing mechanics. Shows good decision-making under pressure.",
              category: "evaluation",
              theme: "coaching_staff_notes",
              source: "main",
              priority: "high",
              pinned: true,
              createdBy: { _id: "1", name: "John Davis" },
              createdAt: "2025-05-08T16:45:00",
              updatedAt: "2025-05-08T16:45:00",
            },
            {
              _id: "4",
              text: "Minor ankle sprain during practice. Expected recovery time: 2-3 weeks.",
              category: "injury",
              theme: "team_notes",
              source: "main",
              priority: "medium",
              createdBy: { _id: "2", name: "Sarah Wilson" },
              createdAt: "2025-05-05T11:20:00",
              updatedAt: "2025-05-05T11:20:00",
            },
          ],
          total: 4,
        };
      } else {
        const queryParams = new URLSearchParams(filters).toString();
        const response = await axios.get(
          `/prospects/${prospectId}/notes?${queryParams}`
        );
        return response.data;
      }
    },

    getLatestNote: async (prospectId) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 200));
        // Return mock latest note
        return {
          success: true,
          data: {
            _id: "1",
            text: "Coach Smith mentioned he has a promising junior quarterback named Robert Davis who could be a good fit for our system.",
            category: "recruiting",
            theme: "team_notes",
            source: "main",
            priority: "medium",
            createdBy: { _id: "1", name: "John Davis" },
            createdAt: "2025-05-15T14:30:00",
            updatedAt: "2025-05-15T14:30:00",
          },
        };
      } else {
        try {
          const response = await axios.get(
            `/prospects/${prospectId}/notes?source=main&limit=1`
          );
          return response.data;
        } catch (error) {
          console.error("Error fetching latest note:", error);
          return { success: false, data: null };
        }
      }
    },

    create: async (prospectId, noteData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 400));
        const newNote = {
          _id: String(Date.now()),
          ...noteData,
          theme: noteData.theme || "team_notes",
          createdBy: { _id: "1", name: "John Davis" },
          createdAt: new Date().toISOString(),
          updatedAt: new Date().toISOString(),
        };
        return { success: true, data: newNote };
      } else {
        const response = await axios.post(
          `/prospects/${prospectId}/notes`,
          noteData
        );
        return response.data;
      }
    },

    update: async (prospectId, noteId, updateData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        return { success: true, data: { _id: noteId, ...updateData } };
      } else {
        const response = await axios.put(
          `/prospects/${prospectId}/notes/${noteId}`,
          updateData
        );
        return response.data;
      }
    },

    delete: async (prospectId, noteId) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        return { success: true, message: "Note deleted successfully" };
      } else {
        const response = await axios.delete(
          `/prospects/${prospectId}/notes/${noteId}`
        );
        return response.data;
      }
    },

    getMainNotes: async (prospectId) => {
      return api.prospectNotes.getAll(prospectId, { noteType: "main" });
    },

    getSecondaryNotes: async (prospectId) => {
      return api.prospectNotes.getAll(prospectId, { noteType: "secondary" });
    },

    getNotesByTheme: async (prospectId, theme) => {
      return api.prospectNotes.getAll(prospectId, { theme });
    },

    getTeamNotes: async (prospectId) => {
      return api.prospectNotes.getAll(prospectId, { theme: "team_notes" });
    },

    getCoachingStaffNotes: async (prospectId) => {
      return api.prospectNotes.getAll(prospectId, {
        theme: "coaching_staff_notes",
      });
    },

    getRecruitingStaffNotes: async (prospectId) => {
      return api.prospectNotes.getAll(prospectId, {
        theme: "recruiting_staff_notes",
      });
    },

    getVisitNotes: async (prospectId) => {
      return api.prospectNotes.getAll(prospectId, { theme: "visit_notes" });
    },

    getEvaluationNotes: async (prospectId) => {
      return api.prospectNotes.getAll(prospectId, { category: "evaluation" });
    },

    getInjuryNotes: async (prospectId) => {
      return api.prospectNotes.getAll(prospectId, { category: "injury" });
    },
  },

  // Coaches
  coaches: {
    getAll: async (params = {}) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 500));
        return SANDBOX_DATA.coaches;
      } else {
        const response = await axios.get("/coaches", { params });
        // Backend returns { success, count, data: [...] }, we need just the data array
        if (response.data && response.data.success && response.data.data) {
          return response.data;
        } else if (Array.isArray(response.data)) {
          return {
            success: true,
            data: response.data,
            count: response.data.length,
          };
        } else {
          return response.data;
        }
      }
    },

    create: async (coachData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 800));
        const newCoach = {
          ...coachData,
          id: String(SANDBOX_DATA.coaches.length + 1),
          createdAt: new Date().toISOString(),
        };
        SANDBOX_DATA.coaches.push(newCoach);
        return newCoach;
      } else {
        const response = await axios.post("/coaches", coachData);
        // Backend might return { success, data: {...} } or just the object
        return response.data.data || response.data;
      }
    },

    update: async (coachId, coachData) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 800));
        const coachIndex = SANDBOX_DATA.coaches.findIndex(
          (coach) => coach.id === coachId
        );
        if (coachIndex !== -1) {
          const updatedCoach = {
            ...SANDBOX_DATA.coaches[coachIndex],
            ...coachData,
            updatedAt: new Date().toISOString(),
          };
          SANDBOX_DATA.coaches[coachIndex] = updatedCoach;
          return {
            success: true,
            data: updatedCoach,
          };
        } else {
          throw new Error("Coach not found");
        }
      } else {
        const response = await axios.put(`/coaches/${coachId}`, coachData);
        return response.data;
      }
    },

    star: async (coachId) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        // Store starred coaches in localStorage for sandbox mode
        const starredCoaches = JSON.parse(
          localStorage.getItem("starredCoaches") || "[]"
        );
        if (!starredCoaches.includes(coachId)) {
          starredCoaches.push(coachId);
          localStorage.setItem(
            "starredCoaches",
            JSON.stringify(starredCoaches)
          );
        }
        return { success: true, message: "Coach starred successfully" };
      } else {
        const response = await axios.post(`/coaches/${coachId}/star`);
        return response.data;
      }
    },

    unstar: async (coachId) => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        // Remove from starred coaches in localStorage for sandbox mode
        const starredCoaches = JSON.parse(
          localStorage.getItem("starredCoaches") || "[]"
        );
        const updatedStarredCoaches = starredCoaches.filter(
          (id) => id !== coachId
        );
        localStorage.setItem(
          "starredCoaches",
          JSON.stringify(updatedStarredCoaches)
        );
        return { success: true, message: "Coach unstarred successfully" };
      } else {
        const response = await axios.delete(`/coaches/${coachId}/star`);
        return response.data;
      }
    },

    getStarred: async () => {
      if (API_CONFIG.MODE === "sandbox") {
        await new Promise((resolve) => setTimeout(resolve, 300));
        // Get starred coaches from localStorage for sandbox mode
        const starredCoachIds = JSON.parse(
          localStorage.getItem("starredCoaches") || "[]"
        );
        const starredCoaches = SANDBOX_DATA.coaches.filter((coach) =>
          starredCoachIds.includes(coach.id)
        );
        return {
          success: true,
          data: starredCoaches,
          count: starredCoaches.length,
        };
      } else {
        const response = await axios.get("/coaches/starred");
        return response.data;
      }
    },
  },
};

// Export current mode for components to check
export const getCurrentMode = () => API_CONFIG.MODE;
export const isDevMode = () => API_CONFIG.MODE === "development";
export const isSandboxMode = () => API_CONFIG.MODE === "sandbox";

export default api;
